import restaurantInstance from '../instance'

const updatePresetDiscounts = (data) => {
	return restaurantInstance.put('/presetDiscounts', { discounts: data })
}

export default updatePresetDiscounts
